export default __webpack_public_path__ + "images/5fe808e647422b815b98b73c28ecf405-3_tablet_1067x470.webp";